import { extend, localize } from 'vee-validate'
import { min, required, email } from 'vee-validate/dist/rules'
// import en from 'vee-validate/dist/locale/en.json'

const rightStringsList = ['croco']

// Install rules
extend('required', required)
extend('min', min)
extend('email', email)
// Validation from backend
extend('unique', {
  validate: (value) =>
    new Promise((resolve) => {
      // db call imitation
      setTimeout(() => {
        if (rightStringsList.indexOf(value) === -1) {
          return resolve({
            valid: true,
          })
        }

        return resolve({
          valid: false,
        })
      }, 200)
    }),
  message: '{_value_} is already used on backend.',
})

// overwrite base messages
localize({
  en: {
    messages: {
      required: 'Required',
      // can't overwrite extended rule message
      unique: 'Already used',
    },
  },
  ro: {
    messages: {
      required: 'E musai',
    },
  },
})
